<template>
  <div class="lowVer-box" v-if="show">
    <div class="wrap"></div>
    <div class="lowVer-dialog-box">
      <div class="lowVer-dialog-content-box">
        <div class="close-header">
          <img @click="closeDlg" src="@img/icon_close.png" alt="" />
        </div>
        <div class="img-content">
          <img src="@img/icon_img.png" alt="" />
        </div>
        <div class="tpi-title-box">
          <p class="tpi-title">该版本不支持该功能！</p>
          <p class="tpi-desc">升级版本，即可使用更多高级功能</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dlgVs: {
      type: Boolean,
      default: function() {
        return false
      }
    }
  },
  data() {
    return {
      show: false,
      verTypeObj: {
        'FREE': '精简版',
        'TEAM': '标准版',
        'ENTERPRISE': '专业版',
        'FLAGSHIP': '旗舰版',
        'PROF': '专业版',
      },
      curVerCode: '',
    };
  },
  watch: {
    dlgVs: {
      handler(newVal) {
        this.show = newVal
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    closeDlg() {
      this.show = false
      this.$emit('update:dlgVs', false)
    }
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9998;
}
.lowVer-dialog-box {
  position: fixed;
  top: 20vh;
  left: 50%;
  width: 314px;
  transform: translateX(-50%);
  height: 468px;
  background-color: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  z-index: 9999;
  .lowVer-dialog-content-box {
    position: relative;
    width: 100%;
  }
  .close-header {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 18px;
    box-sizing: border-box;
    img {
      cursor: pointer;
    }
  }
  .img-content {
    margin-top: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tpi-title-box {
    text-align: center;
    .tpi-title {
      font-size: 16px;
      color: #575757;
      margin-top: 30px;
    }
    .tpi-desc {
      margin-top: 11px;
      color: #888888;
    }
  }
  .tpi-btn {
    margin-top: 40px;
    display: flex;
    justify-content: center;
  }
}
</style>